import { message as antdMessage } from "antd";
import { confirmDialog } from "@/utils/confirmDialog";

// React 模板的 TypeScript 配置不再提供 Vue 工程中的 Decorator 全局类型，这里保留旧装饰器的最小契约。
type Decorator = (target: object, propertyKey: string | symbol, descriptor: PropertyDescriptor) => void;

type ConfirmableOptions = {
    /**状态在参数中的索引, 默认参数最后一项 */
    switchParamIndex?: number;
    /**消息文本 */
    msgs: [string, string];
    /**确认后的消息提示文本 */
    completedMsgs?: [string, string];
    /**当参数为对象时, 状态参数的字段名 */
    switchParamFiled?: string;
};
function confirmable(options: ConfirmableOptions): Decorator;
function confirmable(msg: string, title?: string, completedMsg?: string, confirmButtonText?: string): Decorator;
function confirmable(
    msg: string | ConfirmableOptions,
    title?: string,
    completedMsg?: string,
    confirmButtonText?: string
): Decorator {
    return (_target, _propertyKey, descriptor) => {
        /**
         * 包裹confirm的函数
         * @param callBack 在确认后需要调用的函数
         * @param msg 确认文本
         * @param completedMsg 确认后的消息提示文本
         * @returns callBack返回值
         */
        const confirmWrapper = async (callBack: Function, msg: string, completedMsg?: string) => {
            const res = await confirmDialog(msg, title ?? "提示", {
                confirmButtonText: confirmButtonText ?? "确认"
            });
            if (res) {
                const result = await callBack();
                /**如果completedMsg不存在, 则截取'是否'后的两个字 */
                const message = completedMsg ?? /是否(.{2})/.exec(msg)?.at(1)?.replace(/^/, "已");
                message && antdMessage.success(message);

                return result;
            }
        };

        const originMethod = descriptor.value as (...args: any[]) => Promise<any>;
        if (typeof msg === "string") {
            descriptor.value = async function (...args: any[]) {
                return await confirmWrapper(async () => await originMethod.apply(this, args), msg, completedMsg);
            };
        } else if (typeof msg === "object") {
            const options = msg;
            descriptor.value = async function (...args: any[]) {
                const switchParamIndex = options.switchParamIndex ?? args.length - 1;
                const switchParamValue = options.switchParamFiled
                    ? args[switchParamIndex][options.switchParamFiled]
                    : args[switchParamIndex];
                return await confirmWrapper(
                    async () => await originMethod.apply(this, args),
                    options.msgs[switchParamValue],
                    options.completedMsgs?.at(switchParamValue)
                );
            };
        }
    };
}
export { confirmable };
